// The list's "add new items to top/bottom" setting - stored per list by the
// ToDoList page (default: todo lists add to top, checklists to bottom)
export const getAddToTop = (list) => {
  try {
    const saved = localStorage.getItem(`todolist-addToTop-${list._id}`);
    if (saved !== null) return JSON.parse(saved);
  } catch {
    // Ignore unreadable storage and use the default
  }
  return list.type !== "checklist";
};

// Put `item` into the section under the given spacer: right below the spacer
// (add-to-top lists) or last in the section, just before the next spacer.
// Returns the items with fresh sortOrders.
export const insertUnderSpacer = (items, spacerId, item, toTop) => {
  const spacerIndex = items.findIndex((i) => i._id === spacerId);
  if (spacerIndex === -1) {
    throw new Error("That spacer no longer exists");
  }
  let index = spacerIndex + 1;
  if (!toTop) {
    while (index < items.length && !items[index].isSpacer) index++;
  }
  const result = [...items];
  result.splice(index, 0, item);
  return result.map((i, sortOrder) => ({ ...i, sortOrder }));
};
